module.exports = __webpack_public_path__ + "img/bottom_center_img.b37b861f.png";